/**
 * ч.793: маршрути «відкрити документ» за типом таблиці — спільно для
 * моніторів (підписань / проведень) і попапів. Типи без власного редактора
 * ведуть на СПИСОК (документ шукається за №); без сторінки — відсутні.
 */
export const DOC_ROUTES: Record<string, (id: string) => string> = {
  // Продажі
  'doc.customer_orders': (id) => `/customer-invoices/${id}`,
  'doc.goods_sales': (id) => `/goods-sales/${id}`,
  'doc.service_acts': (id) => `/service-acts/${id}`,
  'doc.tnn': (id) => `/tnn/${id}`,
  'doc.goods_returns_from_customer': (id) => `/goods-returns-from-customer/${id}`,
  'doc.fixed_asset_sale': (id) => `/assets/sale/${id}`,
  'doc.commission_sale': () => '/commission/sale',
  'doc.commission_settlement_report': () => '/commission/settlement',
  'doc.processing_services_sales': (id) => `/processing-services-sales/${id}`,
  'doc.production_service_acts': (id) => `/production-service-acts/${id}`,
  // Закупівлі
  'doc.supplier_orders': (id) => `/supplier-invoices/${id}`,
  'doc.goods_receipts': (id) => `/goods-receipts/${id}`,
  'doc.goods_returns_to_supplier': (id) => `/goods-returns-to-supplier/${id}`,
  'doc.additional_expenses': (id) => `/additional-expenses/${id}`,
  'doc.customs_declarations': (id) => `/customs-declarations/${id}`,
  'doc.material_receipt_for_processing': (id) => `/material-receipts-for-processing/${id}`,
  'doc.processing_receipts': (id) => `/processing-receipts/${id}`,
  // Договори та звірки
  'ref.contracts': (id) => `/refs/contracts/${id}`,
  'doc.civil_law_contracts': (id) => `/civil-law-contracts/${id}`,
  'doc.reconciliation_acts': (id) => `/settlements/reconciliation-acts/${id}`,
  'doc.powers_of_attorney': (id) => `/settlements/powers-of-attorney/${id}`,
  'doc.settlement_inventories': (id) => `/settlements/settlement-inventories/${id}`,
  // Склад та внутрішні
  'doc.goods_transfers': (id) => `/goods-transfers/${id}`,
  'doc.goods_writeoffs': (id) => `/goods-writeoffs/${id}`,
  'doc.inventory_counts': (id) => `/inventory-counts/${id}`,
  'doc.goods_recognitions': (id) => `/goods-recognitions/${id}`,
  'doc.warehouse_orders': (id) => `/warehouse/orders/${id}`,
  'doc.production_reports': (id) => `/production-reports/${id}`,
  'doc.material_transfer_for_processing': (id) => `/material-transfers-for-processing/${id}`,
  'doc.material_requisitions': (id) => `/material-requisitions/${id}`,
  'doc.product_assemblies': (id) => `/product-assemblies/${id}`,
  'doc.product_disassemblies': (id) => `/product-disassemblies/${id}`,
  'doc.tare_transfer': (id) => `/tare-transfers/${id}`,
  'doc.tare_return': (id) => `/tare-returns/${id}`,
  'doc.manual_operations': (id) => `/manual-operations/${id}`,
  'doc.price_change': (id) => `/retail/price-changes/${id}`,
  // Каса і банк
  'doc.cash_receipts': (id) => `/cash-receipts/${id}`,
  'doc.cash_payments': (id) => `/cash-payments/${id}`,
  'doc.bank_receipts': (id) => `/bank-receipts/${id}`,
  'doc.bank_payments': (id) => `/bank-payments/${id}`,
  'doc.advance_reports': (id) => `/advance-reports/${id}`,
  'doc.fund_receipts': (id) => `/fund-receipts/${id}`,
  'doc.currency_purchase_sale': (id) => `/banking/currency-operations/${id}`,
  'doc.fx_revaluations': (id) => `/fx-revaluations/${id}`,
  'doc.debt_adjustments': (id) => `/debt-adjustments/${id}`,
  'doc.doubtful_debt_reserves': (id) => `/doubtful-debt-reserves/${id}`,
  'doc.opening_balances': (id) => `/opening-balances/${id}`,
  // Зарплата
  'doc.payrolls': (id) => `/payrolls/${id}`,
  'doc.payroll_payments': (id) => `/payroll-payments/${id}`,
  'doc.salary_deposits': (id) => `/salary-deposits/${id}`,
  'doc.tax_remittances': (id) => `/tax-remittances/${id}`,
  'doc.vacation_orders': (id) => `/hr/vacation-orders/${id}`,
  'doc.sick_leaves': (id) => `/hr/sick-leaves/${id}`,
  'doc.vacation_compensations': (id) => `/hr/vacation-compensations/${id}`,
  'doc.timesheets': (id) => `/timesheets/${id}`,
  'doc.daily_timesheets': (id) => `/daily-timesheets/${id}`,
  'doc.planned_accrual_orders': (id) => `/payroll/planned-accrual-orders/${id}`,
  // Кадри
  'doc.hire_orders': (id) => `/hire-orders/${id}`,
  'doc.staff_transfers': (id) => `/staff-transfers/${id}`,
  'doc.dismissal_orders': (id) => `/dismissal-orders/${id}`,
  'doc.absence_orders': (id) => `/absence-orders/${id}`,
  'doc.staff_schedules': () => '/staff-schedule',
  // Податки
  'tax.tax_invoices_outgoing': (id) => `/tax-invoices-outgoing/${id}`,
  'tax.tax_invoices_incoming': (id) => `/tax-invoices-incoming/${id}`,
  'doc.advance_payment_tax_registration': (id) => `/taxation/advance-payment-registrations/${id}`,
  'doc.expected_vs_confirmed_vat_adjustments': (id) => `/taxation/expected-confirmed-vat-adj/${id}`,
  'doc.proportional_vat_coefficient': (id) => `/taxation/proportional-vat-coefficient/${id}`,
  'doc.proportional_vat_recalculation': (id) => `/taxation/proportional-vat-recalculation/${id}`,
  'doc.tax_purpose_adjustments_inventory': (id) => `/taxation/tax-purpose-adj-inventory/${id}`,
  'doc.tax_purpose_adjustments_tzr': (id) => `/taxation/tax-purpose-adj-tzr/${id}`,
  // Необоротні активи
  'doc.asset_commissioning': (id) => `/assets/commissioning/${id}`,
  'doc.asset_write_off': (id) => `/assets/write-off/${id}`,
  'doc.asset_internal_transfer': (id) => `/assets/transfer/${id}`,
  'doc.fixed_asset_inventory': (id) => `/assets/inventory/${id}`,
  'doc.asset_tax_purpose_changes': (id) => `/assets/tax-purpose/${id}`,
  'doc.fixed_asset_modernization': (id) => `/assets/state-change/m/${id}`,
  'doc.asset_state_change': (id) => `/assets/state-change/s/${id}`,
};
